import { useMediaQuery } from '@/shared/hooks/useMediaQuery';
import { SIDE_MENU_BREAKPOINTS } from '@/shared/libs/side-menu-breakpoints';

export const useIsDesktopSideMenu = () =>
  useMediaQuery(`(min-width: ${SIDE_MENU_BREAKPOINTS.mobile}px)`);
